MOVE.VIDEOS = (function (MOVE) {
	"use strict";
    var init = function () {
    };
    MOVE.VIDEOS =
    {
        init: init
    };
    return MOVE.VIDEOS;
})(MOVE || {});



// WEBPACK FOOTER //
// ./videos/videos.js